import { t } from "@lingui/macro"

import { IContractDataItem } from "src/views/contracts/types"

/**
 * Returns a list of contract data fields with their labels
 */
export const getContractDataList = (): IContractDataItem[] => [
    { label: t`contract-details.agreement-no`, key: "agreement_no" },
    { label: t`contract-details.annual-rent`, key: "annual_rent" },
    { label: t`contract-details.created-date`, key: "created_date" },
    { label: t`contract-details.external-id`, key: "external_id" },
    { label: t`contract-details.integration-id`, key: "integration_id" },
    { label: t`contract-details.lease-contract-id`, key: "lease_contract_id" },
    { label: t`contract-details.lease-from`, key: "lease_from" },
    { label: t`contract-details.lease-to`, key: "lease_to" },
    { label: t`contract-details.legal-entity-id`, key: "legal_entity_id" },
    { label: t`contract-details.legal-entity-name`, key: "legal_entity" },
    { label: t`contract-details.monthly-rent`, key: "monthly_rent" },
    {
        label: t`contract-details.property-object-id`,
        key: "property_object_id",
    },
    { label: t`contract-details.status`, key: "status" },
]

/**
 * Returns a list of object data fields with their labels
 */
export const getObjectDataList = (): IContractDataItem[] => [
    { label: t`contract-details.object-type`, key: "object_type" },
    { label: t`contract-details.property-owner`, key: "property_owner" },
    {
        label: t`contract-details.object-no-internal`,
        key: "object_no_internal",
    },
    {
        label: t`contract-details.object-no-external`,
        key: "property_object_external_id",
    },
    { label: t`contract-details.object-no-land-survey`, key: "object_no_lm" },
]
